import ReactSelect from 'react-select';
import type { GroupBase, Props as ReactSelectProps } from 'react-select';

interface SelectProps<Option = any> extends ReactSelectProps<Option, false, GroupBase<Option>> {
  required?: boolean;
}

export function Select<Option = any>({
  className = '',
  name,
  required = false,
  onChange,
  value,
  components,
  placeholder,
  options,
  isSearchable = false,
  getOptionLabel,
  getOptionValue,
  ...restProps
}: SelectProps<Option>) {
  return (
    <ReactSelect
      {...restProps}
      className={className}
      required={required}
      name={name}
      options={options}
      placeholder={placeholder}
      isSearchable={isSearchable}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onChange={onChange}
      components={{
        IndicatorSeparator: () => null,
        ...components
      }}
      value={value}
      styles={{
        container: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.container?.(baseStyles, state),
          width: '100%'
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.control?.(baseStyles, state),
          // border: state.isFocused ? '1px solid #7888F5' : '1px solid #CDD4DF',
          border: state.isFocused ? '1px solid #CDD4DF' : '1px solid #CDD4DF',
          boxShadow: 'none',
          minHeight: '36px',
          width: '100%',
          borderRadius: '4px',
          outline: 'none',
          ...((restProps.styles?.control && restProps.styles?.control(baseStyles, state)) || {})
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.valueContainer?.(baseStyles, state),
          padding: '0 8px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.placeholder?.(baseStyles, state),
          color: '#ADB5BD',
          fontSize: '14px',
          lineHeight: '16px',
          fontWeight: '400',
          margin: 0,
          opacity: 1,
          ...((restProps.styles?.placeholder && restProps.styles?.placeholder(baseStyles, state)) ||
            {})
        }),
        menuPortal: baseStyles => ({
          ...baseStyles,
          zIndex: 1000
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.menu?.(baseStyles, state),
          margin: 0,
          padding: 0,
          boxShadow:
            '0px 7px 15px 0px rgba(0, 0, 0, 0.10), 0px 27px 27px 0px rgba(0, 0, 0, 0.09), 0px 62px 37px 0px rgba(0, 0, 0, 0.05), 0px 110px 44px 0px rgba(0, 0, 0, 0.01), 0px 171px 48px 0px rgba(0, 0, 0, 0.00)',
          borderRadius: '4px',
          // border: '1px solid #7888F5',
          border: '1px solid #CDD4DF',
          overflow: 'hidden',
          ...((restProps.styles?.menu && restProps.styles?.menu(baseStyles, state)) || {})
          //   top: '40px'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.input?.(baseStyles, state),
          margin: 0,
          padding: 0,
          fontSize: '14px',
          lineHeight: '16px',
          ...((restProps.styles?.input && restProps.styles?.input(baseStyles, state)) || {})
        }),
        menuList: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.menuList?.(baseStyles, state),
          padding: 0
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.option?.(baseStyles, state),
          padding: '9px 16px',
          fontSize: '14px',
          lineHeight: '16px',
          color: state.isSelected ? '#495BD1' : '#5C5D61',
          borderBottom: '1px solid #E2E2E2',
          backgroundColor: state.isSelected ? '#F3F3FF' : '#fff',
          '&:hover': {
            background: '#F3F3FF',
            color: '#495BD1'
          },
          ...((restProps.styles?.option && restProps.styles?.option(baseStyles, state)) || {})
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.singleValue?.(baseStyles, state),
          fontWeight: 400,
          color: '#000',
          fontSize: '14px',
          lineHeight: '16px',
          ...((restProps.styles?.singleValue && restProps.styles?.singleValue(baseStyles, state)) ||
            {})
        }),
        indicatorsContainer: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.indicatorsContainer?.(baseStyles, state),
          padding: '0!important'
        }),
        dropdownIndicator: (baseStyles, state) => ({
          ...baseStyles,
          ...restProps?.styles?.dropdownIndicator?.(baseStyles, state),
          padding: '6px 4px 6px 0!important',
          svg: {
            width: '16px',
            height: '16px'
          },
          ...((restProps.styles?.dropdownIndicator &&
            restProps.styles?.dropdownIndicator(baseStyles, state)) ||
            {})
        })
      }}
    />
  );
}
